<template>
  <div>
    <settings-card :config="config">
      <el-button
        type="text"
        @click="payApply">
        去设置
      </el-button>
      <!-- <el-dropdown>
        <el-button type="text">
          去设置<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in list"
            :key="item.expressCode"
            @click.native="payApply(item)">{{ item.expressName }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </settings-card>
    <template-modal ref="modal" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SettingsCard from './settings-card.vue'
import TemplateModal from './template-modal'

export default {
  name: 'SeriesCard',
  components: {
    SettingsCard,
    TemplateModal
  },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  // mounted() {
  //   this.fetchList()
  // },
  methods: {
    payApply() {
      this.$refs.modal.fetch({
        vendorId: this.userInfo.vendorId
      })
    }
  }
}
</script>
